<template lang="pug">
div(:class="$style.headerCards")
  CategoryCard(
    title="Car shipping"
    :link-path="getAbsoluteUrl('send-goods/vehicle_move')"
    image-peeks-out
    animate-from="bottom"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/cars-us_1x.webp"
        srcset="~/assets/img/homepage/cars-us_2x.webp 2x"
        alt="Car shipping"
        style="--image-width: 420px; --image-height: 370px;"
      )
  CategoryCard(
    title="Truck shipping"
    :link-path="getAbsoluteUrl('send-goods/vehicle_move')"
    image-peeks-out
    animate-from="bottom"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/truck-us_1x.webp"
        srcset="~/assets/img/homepage/truck-us_2x.webp 2x"
        alt="Truck shipping"
        style="--image-width: 420px; --image-height: 370px;"
      )
  CategoryCard(
    title="Motorcycle shipping"
    :link-path="getAbsoluteUrl('send-goods/vehicle_move')"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/motorbike-us_1x.webp"
        srcset="~/assets/img/homepage/motorbike-us_2x.webp 2x"
        alt="Motorcycle shipping"
        style="--image-width: 272px; --image-height: 215px;"
      )
  CategoryCard(
    title="Furniture delivery"
    link-path="/us/furniture-enquiry-form"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/furniture_variant_1x.webp"
        srcset="~/assets/img/homepage/furniture_variant_2x.webp 2x"
        alt="Furniture delivery"
        style="--image-width: 272px; --image-height: 215px;"
      )
  CategoryCard(
    title="Home removals"
    link-path="/us/home-removals-enquiry"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/removals_variant_1x.webp"
        srcset="~/assets/img/homepage/removals_variant_2x.webp 2x"
        alt="Home removals"
        style="--image-width: 272px; --image-height: 215px;"
      )
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "HeaderCardsUS",
  methods: {
    trackCardClick(title: string) {
      this.$snowplow.trackCategoryCardClick(title)
    },
    getAbsoluteUrl(path: string): string {
      return `${this.$config.public.v4Host.replace("com", this.$i18n.locale)}/${path}`
    }
  }
})
</script>

<style module lang="css">
.headerCards {
  @apply grid gap-ds-md md:gap-ds-ml;
  display: grid;
  grid-auto-rows: min-content;
  grid-template-rows: auto auto; /* Two rows */
  grid-template-columns: repeat(6, 1fr); /* First row with two equal columns */

  /* Explicitly place the first two children in the first row */

  > :nth-child(1) {
    grid-column: 1 / 4;
  }

  > :nth-child(2) {
    grid-column: 4 / 7;
  }

  > :nth-child(3) {
    grid-column: 1 / 3;
  }

  > :nth-child(4) {
    grid-column: 3 / 5;
  }

  > :nth-child(5) {
    grid-column: 5 / 7;
  }

  .largeLoadingPlaceholder {
    aspect-ratio: 42 / 37; /* Fixes layout shift prior to images loading */
  }

  .smallLoadingPlaceholder {
    aspect-ratio: 272 / 215; /* Fixes layout shift prior to images loading */
  }
}
</style>
